import { API_URL } from "helpers/constant";

export async function upload(body) {
  return await fetch(`${API_URL}/upload`, {
    method: "POST",
    body,
  });
}
